<template>
	<vTable :columns="columns" :data="data" border></vTable>
</template>
<script>
export default {
    props:['data'],
	computed: {
		columns() {
			return [{
				title: '操作人',
				key: 'updatedName',
			}, {
				title: '操作类型',
				key: 'opAction',
			}, {
				title: '操作原因 ',
				key: 'opRemark',
			}, {
				title: '操作时间 ',
				key: 'createdAt',
			}];
		}
	}
}
</script>
